export default __webpack_public_path__ + "static/july-sale-desktop-ff48345bc5372864a353c201545af582.webp";